import cn from 'classnames';
import {
  IncludedProduct,
  StaticPDPProduct,
} from 'modules/product-details/types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import BundleItem from './bundle-item';

interface PropTypes {
  product: StaticPDPProduct;
  includedProducts: Array<IncludedProduct>;
}

const IncludedProducts: React.FC<PropTypes> = ({
  product,
  includedProducts,
}) => {
  const shouldBeHidden = useMemo(
    () => product && product.tags.some((tag) => /hidebundle/i.test(tag)),
    [product]
  );

  if (shouldBeHidden) {
    return null;
  }

  return (
    <div>
      <div className="text-md my-8 text-center font-black text-primary-main lg:text-lg">
        {product.metadata.accentuate.mainTitle || product.title}{' '}
        <span className="font-normal lg:font-black">
          <FormattedMessage id="pdp:included-products" />
        </span>
      </div>
      <div className="flex w-auto overflow-auto lg:mx-auto lg:flex-wrap lg:justify-center lg:overflow-hidden">
        {includedProducts.map((includedProduct, index) => {
          if (includedProduct.product) {
            return (
              <BundleItem
                className={cn({
                  'ml-4  lg:ml-8': index > 0,
                })}
                key={includedProduct.product.id}
                product={includedProduct.product}
                variantId={includedProduct.variantId}
                quantity={includedProduct.quantity}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default IncludedProducts;
